var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee"},[_c('div',{staticClass:"marquee_box"},[_c('ul',{staticClass:"marquee_list",class:{marquee_top:_vm.animate}},_vm._l((_vm.marqueeList),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item.name))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }